import { useEffect, useState } from "react";
import "./CartSectionComponent.scss";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { myCart, myCartClear } from "../../../redux/Cart/actions";
import _ from "lodash";
import CONFIG from "../../../utils/config";
import ProductCardComponent from "../ProductCard/ProductCardComponent";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import FormButtonComponent from "../FormControl/FormButton/FormButtonComponent";
import { CheckoutLockIcon } from "../../../utils/SvgComps";
import ConfirmModal from "../../modal/ConfirmModal";
import CartCardSectionComponent from "./CartCardSectionComponent";
import Loader from "../../Loader/Loader";
import { cartPageDataResponse } from "../../../redux/checkout/actions";
import { useNavigate } from "react-router-dom";
import { routeList } from "../../../utils/routeList";
import { formatCartProductData } from "../../../utils/AppUtils";
import NotFoundComponent from "../NotFound/NotFoundComponent";

const CartSectionComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const myCartRes = useSelector((state) => state.carts.myCart);

  const [isLoading, setIsLoading] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [cartTotal, setCartTotal] = useState(0);
  const [productArr, setProductArr] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );
  const [confirmModal, setConfirmModal] = useState(false);

  const [apiCalled, setApiCalled] = useState(false);
  useEffect(() => {
    window.scrollTo(0,0);
    fetchMyCart();
  }, [dispatch]);

  useEffect(() => {
    console.log("myCartRes", myCartRes);
    if (!_.isEmpty(myCartRes)) {
      const cartList = myCartRes.cart_list;
      if (!_.isEmpty(cartList)) {
        setProductArr(
          _.map(cartList, (cartData) => {
            cartData.is_cart = true;
            return formatCartProductData(cartData);
          })
        );
        setCartTotal(
          _.sumBy(cartList, (cartData) =>
            _.toNumber(cartData.product_sale_price)
          )
        );
      } else {
        setProductArr([]);
      }
      setIsLoading(false);
      setIsPageLoading(false);
      // dispatch(myCartClear())
    } else if (apiCalled) {
      setProductArr([]);
      setIsLoading(false);
      setIsPageLoading(false);
    } else {
    }
  }, [myCartRes]);

  const fetchMyCart = () => {
    setApiCalled(true);
    dispatch(
      myCart({
        module: "myCart",
      })
    );
  };

  const redirectToCheckout = () => {
    dispatch(cartPageDataResponse({ load: true, productId: "" }));
    setIsPageLoading(true);
    setTimeout(() => {
      navigate(routeList.PAYMENT_PAGE_PRODUCT);
    }, 2000);
  };

  return (
    <>
      <Loader start={isPageLoading} />
      <section className="my_cart-b2c">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="cart-title-b2c">Cart</h2>
              {isLoading ? (
                <ShimmerScreen case="rect" width="15rem" height="1rem" />
              ) : productArr.length > 0 ? (
                <p className="sub-cart-title">
                  There are {productArr.length} item(s) in your cart
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="row cart-listing">
            {productArr.length > 0 ? (
              productArr.map((p, i) => {
                return (
                  <>
                    <CartCardSectionComponent
                      {...p}
                      key={`cart-${i + 1}`}
                      setIsLoading={setIsPageLoading}
                    />
                    {/* <ProductCardComponent {...p} key={`cart-${i + 1}`} /> */}
                    {/* <div className="sep"></div> */}
                  </>
                );
              })
            ) : (
              <NotFoundComponent
                width={400}
                height={419}
                showBtn={true}
                btnName={"Explore"}
                btnAction={() => navigate("/learn/courses?tab=1")}
                showMsg={true}
                msgLine={"No item presently in cart."}
              />
            )}
          </div>
        </div>
        {isLoading || productArr.length == 0 ? (
          ""
        ) : (
          <div className="cart-footer">
            <div className="container">
              <div className="row">
                <div className="col-md-12 d-flex align-items-center justify-content-end">
                  <div className="cart-price-box">
                    <div className="price-box-text">
                      <strong>Total</strong>
                      <span>Excl. of taxes</span>
                    </div>
                    {isLoading ? (
                      <ShimmerScreen case="rect" width="5rem" height="3rem" />
                    ) : (
                      <div className="price-footer">CA ${cartTotal}</div>
                    )}
                  </div>
                  <div className="checkout-btn-sec">
                    <FormButtonComponent
                      btnName="Checkout"
                      leftIcon={<CheckoutLockIcon />}
                      rightIcon=""
                      altText="checkout"
                      btnAction={() => redirectToCheckout()}
                      isPrimary={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};
export default CartSectionComponent;
